export default "__VITE_ASSET__D77CDeMX__"